module.exports = __webpack_public_path__ + "img/trieste.e7f35c3a.jpg";